import Vue from 'vue';
import { EventManager } from '../vue/EventManager.js';
import AOS from 'aos';
import VueRouter from 'vue-router';
import VueLazyload from 'vue-lazyload';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import TestComponent from '../vue/TestComponent.vue';
import SiteHeader from '../vue/SiteHeader.vue';
import SiteFooter from '../vue/SiteFooter.vue';
// import IconListing from '../vue/IconListing.vue';
// import ResourceListing from '../vue/ResourceListing.vue';
// import ProjectListing from '../vue/ProjectListing.vue';
// import SingleCta from '../vue/SingleCta.vue';
// import QuickLinks from '../vue/QuickLinks.vue';
// import SlimHeader from '../vue/SlimHeader.vue';
import RichText from '../vue/RichText.vue';
// import VideoButton from '../vue/VideoButton.vue';
// import FeaturedCta from '../vue/FeaturedCta.vue';
// import AlertBanner from '../vue/AlertBanner.vue';
// import MobileMenu from '../vue/MobileMenu.vue';
import PrimaryButton from '../vue/PrimaryButton.vue';
import SecondaryButton from '../vue/SecondaryButton.vue';
import TertiaryButton from '../vue/TertiaryButton.vue';
// import AcknowledgementOfCountry from '../vue/AcknowledgementOfCountry.vue';
import SearchListing from '../vue/SearchListing.vue';
import LoadingAnimation from '../vue/LoadingAnimation.vue';
import BreadCrumbs from '../vue/BreadCrumbs.vue';
import NotFound from '../vue/NotFound.vue';
import PageDivider from '../vue/PageDivider.vue';
import HeroHeader from '../vue/HeroHeader.vue';
import StandardHeader from '../vue/StandardHeader.vue';
// import SlimHeader from '../vue/SlimHeader.vue';
import VideoImage from '../vue/VideoImage.vue';
import TerminologyListing from '../vue/TerminologyListing.vue';
// import FeaturedContent from '../vue/FeaturedContent.vue';
import MultiColumn from  '../vue/MultiColumn.vue';
import TestimonialColumn from  '../vue/TestimonialColumn.vue';
import MediaAndText from '../vue/MediaAndText.vue';
import StatisticsModule from '../vue/StatisticsModule.vue';
// import ProofPoints from '../vue/ProofPoints.vue';
// import ImageGallery from '../vue/ImageGallery.vue';
// import SingleQuote from '../vue/SingleQuote.vue';
import MixedContent from '../vue/MixedContent.vue';
// import ContentSlider from '../vue/ContentSlider.vue';
// import ImageSlider from '../vue/ImageSlider.vue';
// import TestimonialSlider from '../vue/TestimonialSlider.vue';
import AccordionItem from '../vue/AccordionItem.vue';
import AccordionItemDisabled from '../vue/AccordionItemDisabled.vue';
import AccordionWrapper from '../vue/AccordionWrapper.vue';
import DownloadsLinks from '../vue/DownloadsLinks.vue';
import RotatingImage from '../vue/RotatingImage.vue';
// import FeaturedCtas from '../vue/FeaturedCtas.vue';
import FeaturedPostListing from '../vue/FeaturedPostListing.vue';
// import FeaturedPeople from '../vue/FeaturedPeople.vue';
// import PostListing from '../vue/PostListing.vue';
import NewsListing from '../vue/NewsListing.vue';
import MobilePageSelect from '../vue/MobilePageSelect.vue';
// import TwoThreeImages from '../vue/TwoThreeImages.vue';
// import ProjectListing from '../vue/ProjectListing.vue';
// import ProjectHeader from '../vue/ProjectHeader.vue';
// import LinksDotpoints from '../vue/LinksDotpoints.vue';
// import LogoListing from '../vue/LogoListing.vue';
// import SingleCta from '../vue/SingleCta.vue';
// import VideoModal from '../vue/VideoModal.vue';
import SignUp from '../vue/SignUp.vue';
import PolicyFinder from '../vue/PolicyFinder.vue';
// import PeopleListing from '../vue/PeopleListing.vue';

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueLazyload);
const router = new VueRouter({ mode: 'history' });

export default {
  init() {
    // JavaScript to be fired on all pages
    let vueArea = document.querySelectorAll('.app');

    let matchingElements = document.getElementsByClassName('vue-disable'),
      hiddenMarkup = [];

    for (var i = 0; i < matchingElements.length; i++) {
      hiddenMarkup.push(matchingElements[i].innerHTML);
      matchingElements[i].innerHTML = '';
    }

    Vue.config.productionTip = false;

    const store = new Vuex.Store({
      state: {
        mobile_menu: false,
        alert_bar_closed: false,
        alert_bar_id: false,
        nav_index_toggle: false,
      },
      getters: {},
      mutations: {
        closeAlertBar(state, payload) {
          state.alert_bar_closed = payload;
        },
        alertBarID(state, payload) {
          state.alert_bar_id = payload;
        },
        toggleMobileMenu(state, payload) {
          state.mobile_menu = payload;
        },
        toggleNavIndex(state, payload) {
          state.nav_index_toggle = payload;
        },
      },
      actions: {},
      plugins: [createPersistedState()],
    });

    if (vueArea) {
      vueArea.forEach((element) => {
        new Vue({
          store: store,
          router,
          data: {
            topScrollThreshold: 100,
            isScrolled: false,
            isPageReady: false,
          },

          components: {
            TestComponent,
            SiteHeader,
            SiteFooter,
            RotatingImage,
            // SiteFooter,
            // IconListing,
            StatisticsModule,
            // QuickLinks,
            // SlimHeader,
            // VideoButton,
            // ImageGallery,
            // FeaturedCta,
            // FeaturedPostListing,
            MixedContent,
            // SingleCta,
            // AlertBanner,
            // MobileMenu,
            PrimaryButton,
            SignUp,
            SecondaryButton,
            // SingleQuote,
            TertiaryButton,
            // AcknowledgementOfCountry,
            SearchListing,
            LoadingAnimation,
            BreadCrumbs,
            NotFound,
            PageDivider,
            HeroHeader,
            StandardHeader,
            // SlimHeader,
            RichText,
            // ResourceListing,
            // ProjectListing,
            NewsListing,
            // ProofPoints,
            VideoImage,
            // FeaturedContent,
            MultiColumn,
            TestimonialColumn,
            MediaAndText,
            TerminologyListing,
            // SingleCta,
            // ContentSlider,
            // ImageSlider,
            // TestimonialSlider,
            AccordionItem,
            AccordionItemDisabled,
            AccordionWrapper,
            // MixedContent,
            DownloadsLinks,
            // FeaturedCtas,
            FeaturedPostListing,
            // FeaturedPeople,
            // PostListing,
            MobilePageSelect,
            // TwoThreeImages,
            // ProjectListing,
            // ProjectHeader,
            // LinksDotpoints,
            // LogoListing,
            // VideoModal,
            // PeopleListing,
            PolicyFinder,
          },

          methods: {
            onRefreshAos: function () {
              AOS.refresh();
            },
            didScroll() {
              this.isScrolled = window.scrollY > this.topScrollThreshold;
              this.updateTrigger();
            },

            updateTrigger() {
              var hash = window.location.hash;
              let navAccordion = document.querySelectorAll(
                '.anchor_links',
              );

              if (hash && navAccordion) {
                navAccordion.forEach((element) => {
                  var accordion_content = element.querySelectorAll('ul li');

                  if (accordion_content) {
                    accordion_content.forEach((element) => {
                      let theLink = element.querySelector('a');

                      if (theLink != null) {
                        if (
                          theLink.href.split('#')[1] === hash.replace('#', '')
                        ) {
                          element.classList.add('current');
                        } else {
                          element.classList.remove('current');
                        }
                      }
                    });
                  }
                });
              }
            },
          },

          created() {
            window.addEventListener('scroll', this.didScroll);
            // this.updateTrigger();
          },

          destroyed() {
            window.removeEventListener('scroll', this.didScroll);
          },

          mounted() {
            var self = this;
            setTimeout(function () {
              self.isPageReady = true;
              AOS.init();
            }, 500);

            self.$Lazyload.$on(
              'loaded',
              /* eslint-disable no-unused-vars */
              function (
                {
                  bindType,
                  el,
                  naturalHeight,
                  naturalWidth,
                  $parent,
                  src,
                  loading,
                  error,
                },
                formCache,
              ) {
                /* eslint-enable no-unused-vars */
                // Lazy loading images can cause AOS to get out of sync because the loaded image changes the height of the content
                // so refreshing it in order to re-calculate trigger points
                EventManager.$emit('should-refresh-aos');
              },
            );


          },
        }).$mount(element);

        /* Re-Attach exclusions
    ---------------------------------------------------------------------------------------------------- */

        for (var ii = 0; ii < matchingElements.length; ii++) {
          matchingElements[ii].innerHTML = hiddenMarkup[ii];
        }
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
